import $ from "jquery";

// $('.faq-section .masonry-grid--item-toggler').on('click', function (){
//     $(this).toggleClass('--active');
//     $(this).closest('.masonry-grid--item').find('.masonry-grid--item-body').slideToggle();
// })